var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { SmallCaption } from "@irati/ui/src/Labels";
import Hr from "@irati/ui/src/Layout/Hr";
import { ButtonRouterLink } from "@irati/ui/src/Link";
import Flex from "@irati/ui/src/Flex";
import { Row, RowMiddle } from "../../Row";
import AdminHeader from "../../AdminHeader/AdminHeader";
import { ADD_TEAM } from "../../../routes/routeConfig";
import Team from "./Team";
var TeamList = function (_a) {
    var setCurrentTeam = _a.setCurrentTeam, teams = _a.teams, formatMessage = _a.formatMessage;
    return (React.createElement(React.Fragment, null,
        React.createElement(Flex, { alignItems: "flex-start", justifyContent: "space-between" },
            React.createElement(AdminHeader, { title: formatMessage({ id: "admin.components.teamList.nameCountAndButton.title" }) }),
            React.createElement(ButtonRouterLink, { primary: true, to: ADD_TEAM, id: "admin_teams_buttonCreateTeam" },
                React.createElement(FormattedMessage, { id: "admin.components.teamList.nameCountAndButton.buttonText" }))),
        React.createElement(Hr, null),
        React.createElement(Row, null,
            React.createElement(RowMiddle, null,
                React.createElement(SmallCaption, { uppercase: true },
                    React.createElement(FormattedMessage, { id: "admin.components.teamList.smallCaption.text" })))),
        teams && teams.map(function (team) { return React.createElement(Team, __assign({ key: team.uuid }, team, { setCurrentTeam: function () { return setCurrentTeam(team); } })); })));
};
export default injectIntl(TeamList);
